import axios from 'axios'
import { setHeaderToken, removeHeaderToken } from '../utils/auth'
import Role from '@/models/Core/Role'
import RoleDetail from '@/models/Core/RoleDetail'

export default {
    state: {
        user: null,
        isLoggedIn: false,
        accessToken: null,
        firstName: null
    },
    mutations: {
        set_user(state, data) {
            state.user = data.user;
            state.userName = data.username;
            state.accessToken = data.token;
            state.isLoggedIn = true;
            state.firstName = data.firstName;
        },
        set_userinfo(state, data) {
            state.user = data.fullName;
            state.userName = data.userName;
            state.firstName = data.firstName;
        },
        reset_user(state) {
            state.user = null;
            state.userName = null;
            state.accessToken = null;
            state.isLoggedIn = false;
            state.firstName = null;
        }
    },
    getters: {
        isLoggedIn: (state) => {
            return state.isLoggedIn
        },
        user(state) {
            return state.user
        },
        accessToken(state) {
            return state.accessToken
        },
        firstName(state) {
            return state.firstName
        }
    },
    actions: {
        login({ dispatch, commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post(`auth/token`, data)
                    .then(response => {
                        const token = response.data.token;
                        localStorage.setItem('access_token', token);
                        setHeaderToken(token);
                        let userdata = {
                            user: '',
                            token: localStorage.getItem('access_token')
                        };
                        commit('set_user', userdata);
                        dispatch('get_user');
                        resolve(response);
                    })
                    .catch(error => {
                        console.log(error);
                        commit('reset_user');
                        localStorage.removeItem('access_token');
                        reject(error);
                    });
            });
        },
        async get_userinfo({commit}) {
            if(!localStorage.getItem('access_token')) {
                return;
            }

            try {
                let response = await axios.get(`UserInfo/Me`);
                localStorage.setItem('user_name', response.data.userName);
                localStorage.setItem('first_name', response.data.firstName);
                commit('set_userinfo', response.data);
            } catch(error) {
                commit('reset_user');
                removeHeaderToken();
                localStorage.removeItem('access_token');
                return error;
            }
        },
        async get_user({commit}) {
            if(!localStorage.getItem('access_token')) {
                return;
            }

            try {
                let userdata = {
                    user: '',
                    username: '',
                    token: localStorage.getItem('access_token')
                };
                commit('set_user', userdata);
            } catch(error) {
                commit('reset_user');
                removeHeaderToken();
                localStorage.removeItem('access_token');
                return error;
            }
        },
        logout({commit}) {
            return new Promise((resolve) => {
                commit('reset_user');
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_name');
                Role.deleteAll();
                RoleDetail.deleteAll();
                removeHeaderToken();
                resolve();
            });
        }
    }
}